export default "__VITE_ASSET__DBlqMYFR__"